import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { clientApi, api, formatErr, imgUrl } from "@/lib/api";
import { useNoReferrer } from "@/lib/useNoReferrer";


export default function ClientLogin() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [img, setImg] = useState("");
  const nav = useNavigate();
  useNoReferrer();
  useEffect(() => {
    api.get("/public/settings").then(({ data }) => {
      if (data.client_login_image) return setImg(data.client_login_image);
      // Nessuna foto impostata: usa la copertina della prima categoria visibile
      return api.get("/public/services").then(({ data: svc }) => setImg(svc.find((s) => s.cover)?.cover || ""));
    }).catch(() => {});
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await clientApi.post("/client/login", { code });
      nav("/area-clienti/evento");
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <section className="min-h-screen grid lg:grid-cols-2" data-testid="client-login-page">
      <div className="hidden lg:block relative overflow-hidden bg-sabbia">
        {img && <img src={imgUrl(img)} alt="" className="absolute inset-0 w-full h-full object-cover" data-testid="client-login-photo" />}
      </div>
      <div className="flex items-center justify-center px-6 pt-32 pb-20">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="client-login-form">
          <KeyRound size={26} strokeWidth={1.2} className="text-sagedark" />
          <p className="eyebrow mt-8">Area clienti</p>
          <h1 className="mt-4 font-serif font-light text-5xl leading-tight">Bentornati.</h1>
          <p className="mt-5 text-stoneish text-sm leading-relaxed">Inserite il codice ricevuto dallo studio per accedere al questionario, alla galleria privata, alla selezione dei preferiti e alla consegna dell'album.</p>
          <input className="field mt-10 tracking-[0.2em] uppercase text-lg" placeholder="SAN-XXXXXX" required value={code}
            onChange={(e) => setCode(e.target.value)} data-testid="client-code-input" />
          <button disabled={busy} className="btn-ink mt-10 w-full justify-center disabled:opacity-50" data-testid="client-login-btn">{busy ? "Verifica..." : "Accedi"}</button>
        </form>
      </div>
    </section>
  );
}
